module.exports = __webpack_public_path__ + "band_15_daughter.ee088a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_15_daughter.png
// module id = 8hRw
// module chunks = 0